export const SET_ACCOUNTS = 'setAccounts'
export const ADD_ACCOUNTS = 'addAccounts'
export const SET_LOADER = 'setLoader'
export const SET_SERVICE = 'setService'
export const RESET_STATE = 'resetState'
